import React from "react"
import { Box } from "@mui/material"
import { AppValueChip } from "@components"


export default function webSuppliersColumn() {
	return {
		name: "web_suppliers_translation", label: "Web Suppliers",
		options: {
			sort: false,
			headerAlign: 'center',
			customBodyRowRenderLite: value => <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 0.5 }}>
				{[...(value ?? [])].sort((a, b) => a.localeCompare(b)).map((item, idx) => (
					<AppValueChip key={idx} tone="accent">{item}</AppValueChip>
				))}
			</Box>,
		}
	}
}